<template>
<div>
  <documents module="project" :modelObj="modelObj"></documents>
</div>
</template>

<script>
export default {
  data () {
    return {
      modelObj: {
        id: this.$route.params.id,
        name: this.$route.query.name
      }
    }
  },
  components: {
    'documents': () => import('@/components/Documents.vue')
  }
}
</script>
